module.exports = __webpack_public_path__ + "img/verification_complete.43b4c772.gif";